/* unplugin-vue-components disabled */import { render } from "./CollectUserLocation.vue?vue&type=template&id=67bf5cdc&scoped=true"
import script from "./CollectUserLocation.vue?vue&type=script&lang=js"
export * from "./CollectUserLocation.vue?vue&type=script&lang=js"

import "./CollectUserLocation.vue?vue&type=style&index=0&id=67bf5cdc&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bf5cdc"]])

export default __exports__